import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useTheme, withStyles } from '@material-ui/core/styles';
import { AppBar, Drawer, Toolbar, List, CssBaseline, Divider } from '@material-ui/core/';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core/';
import { IconButton, Icon } from '@material-ui/core/';
import { Menu, ChevronLeft, ChevronRight, Close } from '@material-ui/icons/';
import { Link } from 'react-router-dom';
import { accountListItems, logoutItem, mainListItems } from './drawerItems.js';
import { ThemeButton } from './ThemeButton'
import { LanguageSwitcher } from './LanguageSwitcher'
import { SignaMedName } from '../utils/SignaMedName.js';
//import { FECYTLogo } from '../utils/FECYTLogo.js';
import {openNewPage} from '../../api/utils/device';
import HelpSnackbar from '../utils/HelpSnackbar';
import { FormDialog } from '../dialog/FormDialog';
import { HelpDialog } from '../dialog/HelpDialog';
import { AccountDialog } from '../dialog/AccountDialog';
import { WebInfoDialog } from '../dialog/WebInfoDialog';
import { red } from '@mui/material/colors';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import device from "current-device";
import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from '../../api/DataProvider';
import { pDB_user_roles } from '../../utils/parameters.js';
import { useTranslation } from "react-i18next";
import { DeviceQueries } from '../utils/DeviceQueries.js';

import "../../styles/devices/mob_Drawer.css";

export function SignaDrawer() {
    const { t } = useTranslation("global")
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const { comm_logout } = useCommProvider();
    const { currentUserRole, json_web_info } = useDataProvider();
    const [openFormDialog, setOpenFormDialog] = useState(false);
    const [sentFormDialog, setSentFormDialog] = useState(false);
    const [openHelpDialog, setOpenHelpDialog] = useState(false);
    const [openAccountDialog, setOpenAccountDialog] = useState(false);
    const [openWebInfoDialog, setOpenWebInfoDialog] = useState(false);
    const [snack, setSnack] = useState({ open: false, text: '' });
    const [darkMode, setDarkMode] = useState(false);
    const [arr_notifications, setArr_notifications] = useState([]);

    /* Drawer actions */
    const handleDrawerOpen = () => {
        if (showDrawer === true) {
            setOpen(true);
        }
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    /* MOB - Nav responsiveness*/
    const queryMatches = DeviceQueries();

    // MOB - Make menu visible when user role is updated
    useEffect(() => {
        if (currentUserRole !== pDB_user_roles.none){
            setShowDrawer(true);
        }
    },[currentUserRole]);

    useEffect(() => {
        try {
            if (json_web_info!==null){
                setArr_notifications(json_web_info.arr_notifications)
            }
        } catch (e) {
            console.warn(e);
        }
    }, [json_web_info]);
    
    const toolbarIcon = window.location.pathname === '/' ? mainListItems[1] : mainListItems[0]; 

    /* Go to login page */
    async function handleLogout() {
        await comm_logout()
        openNewPage('/sign')
    }

    async function actionDrawerButtonByName(text) {
        switch (text) {
            case "sDrawer.feedback":
                setOpenFormDialog(true);
            break;
            case "sDrawer.help":
                setOpenHelpDialog(true);
            break;
            case "sDrawer.account":
                setOpenAccountDialog(true);
            break;
            case "sDrawer.monitor":
                setOpenWebInfoDialog(true);
            break;
            case "sDrawer.telegramBot":
                window.open('https://t.me/signasalud_bot', "_blank", "noopener,noreferrer");
            break;
            default:
              //Declaraciones ejecutadas cuando ninguno de los valores coincide con el valor de la expresión
            break;
        }
    }

    useEffect(() => {

        if (sentFormDialog===true){
            setSnack({ ...snack, open: true, text: 'Feedback enviado. Gracias por su colaboracion :)', type: 'info' });
            setSentFormDialog(false)
        }

    }, [openFormDialog, sentFormDialog, snack])

    const getColor = () => {
        return red[500]
    }

    const ReportTooltip = withStyles({
        tooltip: {
            fontSize: "12px",
            color: "black",
            backgroundColor: red[300]
        }
    })(Tooltip);

    const handleThemeSwitch = (event, newDarkMode) => {
        setDarkMode(newDarkMode)
    };


    return (
        <div className={ darkMode ? "sig_Home_DrawerRoot sig_Home_DarkMode" : "sig_Home_DrawerRoot"} >
            <CssBaseline />
            <AppBar
                color='inherit'
                position="fixed"
                elevation={2}
                // MOB - Keep it like this for now, but check for simpler method later
                // clsx is used to apply styles on conditions
                className={clsx('sig_Home_MenuBar', {
                    'sig_Home_MenuBarShifted': open
                })}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        //edge="start"
                        className={clsx('tourSearchLSE_1 sig_Home_MenuButton sig_Home_ChangeOnDarkMode', {
                            'sig_Home_MenuButtonShifted': open,
                            'sig_Home_MenuButtonDisabled': !showDrawer,
                        })}>
                        <Menu />
                    </IconButton>
                    { !queryMatches.deviceLandscape ? (
                            <>
                            <SignaMedName className='sig_Home_DrawerTitle' width={160}/> 
                            </>
                            )
                            : <></> }

                    {/* <div style={{ position:'fixed', right: '220px', width: '250px', height: '50px', fontSize: '15px', backgroundColor: '#d0e6fa', border: '2px solid #5ea0d4', color: 'black', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {currentUserRole == pDB_user_roles.admin
                        ?   <p><strong>VISTA - ROL:</strong>&nbsp;ADMINISTRADOR</p>
                        :   <p><strong>VISTA - ROL:</strong>&nbsp;REGISTRADO</p>
                        }
                    </div> */}

                    { queryMatches.desktop ?                     
                            <div className='sig_Home_ThemeSwitch sig_Home_ChangeOnDarkMode'>
                                <div style={{display: 'flex'}}>
                                    <ThemeButton className='sig_Home_DrawerThemeSwitch sig_Home_ChangeOnDarkMode' handleThemeSwitch={handleThemeSwitch} />
                                    <LanguageSwitcher/>  
                                </div>
                            </div>
                    : queryMatches.deviceLandscape ? <></> 
                    : <Tooltip key={t(toolbarIcon.text)} title={t(toolbarIcon.text)} placement="bottom-end" arrow>
                        <Link key={toolbarIcon.text} className={`sig_Home_Link sig_Home_ToolbarIcon ${showDrawer ? '' : 'sig_Home_ToolbarIconDisabled'}`} to={showDrawer ? toolbarIcon.link : "#"}>
                            <Icon className='sig_Home_ChangeOnDarkMode'> {toolbarIcon.iconPrimary} </Icon>
                        </Link>
                    </Tooltip> 
                    }

                </Toolbar>
            </AppBar>
            <div className={clsx('sig_Home_DrawerBkg', {
                'sig_Home_DrawerOpenBkg': open,
                'sig_Home_DrawerCloseBkg': !open,
            })} onClick={handleDrawerClose}>            
            </div>
            <Drawer
                variant="permanent"
                className={clsx('sig_Home_Drawer', {
                    'sig_Home_DrawerOpen': open,
                    'sig_Home_DrawerClose': !open,
                })}
                classes={{
                    paper: clsx({
                        'sig_Home_DrawerOpen': open,
                        'sig_Home_DrawerClose': !open,
                        'sig_Home_DrawerHidden': !showDrawer,
                        'sig_Home_DrawerVisible': showDrawer,
                    }),
                }}>               
                <div className='sig_Home_ToolbarSpace'>
                    { !queryMatches.desktop ?  
                        <div style={{display: 'flex'}}>
                                             
                            <ThemeButton className='sig_Home_DrawerThemeSwitch sig_Home_ChangeOnDarkMode' handleThemeSwitch={handleThemeSwitch} />
                            <LanguageSwitcher/> 
                        </div>
                    : <></> }
                    { queryMatches.deviceLandscape ? (
                            <>
                            <SignaMedName className='sig_Home_DrawerTitle' width={150}/> 
                            </>
                            )
                            : <></> }

                    <IconButton className='sig_Home_ChangeOnDarkMode' onClick={handleDrawerClose}>
                        {queryMatches.desktop ? (theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />) : <Close color="primary"/>}
                    </IconButton>
                </div>
                <Divider />
                <List className='sig_Home_DrawerList'>
                    {mainListItems.map(item => {
                        const { text, iconPrimary, link, roles } = item;
                        return (
                                ( roles.includes(currentUserRole) ) ?(
                                        <Tooltip key={t(text)} title={t(text)} placement="right" arrow>
                                            <Link key={text} className='sig_Home_Link' to={link}>
                                                <ListItem  key={text} button >
                                                    <ListItemIcon className='sig_Home_ChangeOnDarkMode'> {iconPrimary} </ListItemIcon>
                                                    <ListItemText primary={t(text)} />
                                                </ListItem>
                                            </Link>
                                        </Tooltip> 
                                    )
                                :<div key={text}></div>
                            )
                        })
                    }
                </List>
                <div className='sig_Home_SettingsPanel'>
                    <Divider />
                    <List className='sig_Home_DrawerList'>

                        {accountListItems.map(item => {
                            const { text, iconPrimary, link, roles } = item;
                            return (
                                    ( roles.includes(currentUserRole) ) ?(
                                            <Tooltip key={t(text)} title={t(text)} placement="right" arrow>
                                                <Link key={text} className='sig_Home_Link' to={link}>
                                                    <ListItem button onClick={() => actionDrawerButtonByName(text)}>
                                                        <ListItemIcon className='sig_Home_ChangeOnDarkMode'> {iconPrimary} </ListItemIcon>
                                                        <ListItemText primary={t(text)} />
                                                    </ListItem>
                                                </Link>
                                            </Tooltip> 
                                        )
                                    :<div key={text}></div>
                                )
                            })
                        }

                        <Divider />
                        {logoutItem.map(item => {
                            const { text, iconPrimary } = item;
                            return (
                                <Tooltip key={t(text)} title={t(text)} placement="right" arrow>
                                    <Link className='sig_Home_Link' to='#'>
                                        <ListItem button
                                            onClick={handleLogout}>
                                            <ListItemIcon className='sig_Home_ChangeOnDarkMode'> {iconPrimary} </ListItemIcon>
                                            <ListItemText primary={t(text)} />
                                        </ListItem>
                                    </Link>
                                </Tooltip> 
                            )
                        })}
                    </List>
                </div>
            </Drawer>
            <FormDialog openDialog={openFormDialog} setOpenDialog={setOpenFormDialog} setSentFormDialog={setSentFormDialog}/>
            <HelpDialog openDialog={openHelpDialog} setOpenDialog={setOpenHelpDialog}/>
            <AccountDialog openDialog={openAccountDialog} setOpenDialog={setOpenAccountDialog}/>
            <WebInfoDialog openDialog={openWebInfoDialog} setOpenDialog={setOpenWebInfoDialog}/>
            <HelpSnackbar snack={snack} setSnack={setSnack} />
        </div >
    );
}
